






import { Component, Mixins } from "vue-property-decorator";

import { WidgetMixin, LayoutMixin } from "./mixins";


@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WRow extends Mixins(WidgetMixin, LayoutMixin) {}
